import UpdateConfigViewer from "../controller/update-config-viewer"
export default function ExportUpdater() {
  return (
    <div>
      <UpdateConfigViewer />
    </div>
  )
}
